import { render } from "./TheCouponImage.vue?vue&type=template&id=b690e61a&scoped=true"
import script from "./TheCouponImage.vue?vue&type=script&lang=js"
export * from "./TheCouponImage.vue?vue&type=script&lang=js"

import "./TheCouponImage.vue?vue&type=style&index=0&id=b690e61a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b690e61a"

export default script